import { render, staticRenderFns } from "./editPurchase.vue?vue&type=template&id=49741544&scoped=true&"
import script from "./editPurchase.vue?vue&type=script&lang=js&"
export * from "./editPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49741544",
  null
  
)

export default component.exports